(() => {
    let openPopupBtn = document.querySelector('#openPopup');
    let popup = document.querySelector('.diu-popup');
    let popupOverlay = document.querySelector('.diu-overlay');
    let popupClose = document.querySelectorAll('.diu-close');

    const initStateReady = () => {
        if (openPopupBtn) {
            openPopupBtn.addEventListener('click', function (event) {
                openPopup(event);
            });
        }
        if (popupOverlay && popupClose) {
            popupOverlay.addEventListener('click', function (event) {
                closePopup(event);
            });
            popupClose.forEach((closeBtn) => {
                closeBtn.addEventListener('click', function (event) {
                    closePopup(event);
                });
            });
        }
    };

    const openPopup = (event) => {
        popup.classList.add('d-block');
        popupOverlay.classList.add('d-block');
        event.preventDefault();
    };

    const closePopup = (event) => {
        popup.classList.remove('d-block');
        popupOverlay.classList.remove('d-block');
        event.preventDefault();
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
